<div class="filter-component-container">

    <div class="filter-component-main container-with-select">
        <mat-form-field>
            <mat-label>Seguradoras</mat-label>
            <mat-select [(ngModel)]="seguradora">
                <mat-option *ngFor="let seguradora of seguradoras" [value]="seguradora.value"><img *ngIf="seguradora.img"
                        class="imgSeg" [ngStyle]="{'width':'40px','height':'40px', 'margin-right':'4px', 'border-radius':'50%'}"
                        [src]="seguradora.img">
                    {{ seguradora.nome }} </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="filter-component-actions">
        <button class="btn-limpar-filtro" (click)="clearFilter()">Limpar Filtros</button>
        <button class="btn-filtro" (click)="buildString()">Aplicar</button>
    </div>
    
</div>